import { Modal, ModalWrapper } from '@braskai/ui-kit';
import { ModalHeaderWithIcon } from '@/shared/ui/modal';
import { useEnterprisePaymentRequiredModalStore } from '../../model/useEnterprisePaymentRequiredModalStore';

const EnterprisePaymentRequiredModalComponent = () => {
  const { close } = useEnterprisePaymentRequiredModalStore();

  return (
    <Modal open onClose={close} size="xs">
      <ModalHeaderWithIcon
        iconType="error"
        title="Unknown Error"
        subtitle={
          <span>
            Please contact the support chat or email us at <a href="mailto:support@rask.ai">support@rask.ai</a>.
          </span>
        }
        onClose={close}
      />
    </Modal>
  );
};

export const EnterprisePaymentRequiredModal = () => (
  <ModalWrapper hook={useEnterprisePaymentRequiredModalStore}>
    <EnterprisePaymentRequiredModalComponent />
  </ModalWrapper>
);
